module.exports = __webpack_public_path__ + "img/1x.c60d454.jpg";